export default __webpack_public_path__ + "static/media/icons - Search.a7dd21f2.svg";